import { call, put } from "redux-saga/effects";
import { REHYDRATE } from "redux-persist/constants";
import authModule from "./AuthModule";
import api from "services/api";

import { createModule, constants } from "./redux-acron";

/**
 * User Module
 * reducer/sagas/actions
 */
export default createModule({
  name: "user",
  modelName: "user",
  state: {
    loading: false,
    data: null
  },
  handlers: {
    [authModule.actionsTypes.signin]: (state, { payload, status }) => {
      if (status === constants.SUCCESS_STATUS) {
        return state.merge({
          data: payload.user
        });
      }
      return state;
    },

    [authModule.actionsTypes.signout]: (state, { payload, status }) => {
      return state.merge({
        data: null
      });
    },

    getInfo: (state, { status = constants.PENDING_STATUS, payload }) => {
      if (status === constants.SUCCESS_STATUS) {
        return state.merge({
          data: payload.data
        });
      }

      return state;
    },

    [REHYDRATE]: (state, { payload }) => {
      return state.merge({
        ...payload.user,
        loading: false
      });
    }
  },
  effects: {
    getInfo: {
      *callback(actions) {
        const response = yield call(api.profile.getInfo);

        if (response.ok) {
          yield put(
            actions.getInfo(
              { data: response.data.data.attributes },
              constants.SUCCESS_STATUS
            )
          );
        }
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/modules/UserModule.js